import React from "react";
import type { additionalQuotationObject, PERIOD_TYPE } from "../../../lib/apis/dtos/request/quotation.request";
import ConfirmModal from "../confirm.modal";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import Button from "../../ui/button";
import type { ADDITIONAL_CATEGORY_TYPE } from "../../../lib/apis/dtos/request/additional.request";
import type { ModalComponentProps } from "../../../types/modal.types";

interface AdditionInstance {
  serviceId: number;
  serviceCode: string;
  serviceName: string;
  telecom: "ALL" | "SK" | "KT" | "LG" | undefined;
  isDefault: boolean;
}
export interface AdditionalObject extends additionalQuotationObject {
  type: "ADD" | "REMAIN" | "CHECK";
}

interface AddtionalCreatedModalProps extends ModalComponentProps {
  onSelected?: (form: additionalQuotationObject[]) => void;
}

const TELECOM_TYPE = [
  { label: "SKT", value: "SK" },
  { label: "KT", value: "KT" },
  { label: "LG U+", value: "LG" },
];

const TELECOM_NAME = {
  ALL: "ALL",
  SK: "SKT",
  KT: "KT",
  LG: "LG U+"
}

export default function AdditionalCreateModal(props: AddtionalCreatedModalProps) {
  const { onSelected, onClose, id } = props;

  const [telecom, setTelecom] = React.useState<ADDITIONAL_CATEGORY_TYPE | undefined>(undefined);
  const [list, setList] = React.useState<AdditionInstance[]>([]);

  return (
    <ConfirmModal
      id={id}
      onClose={onClose}
      className="w-[600px]"
      title="부가서비스 항목 추가"
      content=""
      rightButton={{
        title: "생성",
        disabled: !telecom || list.some(({ serviceName }) => serviceName == "") || list.length == 0,
        onClick: () => {
          let _list = [] as additionalQuotationObject[];
          list.map((item) => _list.push({
            ...item,
            telecom: item.telecom as ADDITIONAL_CATEGORY_TYPE,
            isMonth: true,
            duration: undefined,
            isVariable: false,
            serviceFee: undefined,
            isMandatory: true,
            periodType: "DAY" as PERIOD_TYPE,
            usePeriod: null,
            nonSubscriptionFee: undefined
          }))
          onSelected?.(_list);
          onClose?.();
        }
      }}
    >
      <p className="text-[16px]">통신사</p>
      <RadioGroup
        className="px-[9px]"
        row
        aria-labelledby="demo-radio-bujttons-group-label"
        name="radio-buttons-group"
      >
        {TELECOM_TYPE.map(({ label, value }, index) => (
          <FormControlLabel
            disabled={list.length > 0}
            key={index}
            value={value}
            control={
              <Radio
                onClick={() =>
                  setTelecom(value as ADDITIONAL_CATEGORY_TYPE)
                  // setList((prev) => prev.map((item, i) => i === 0 ? {...item, telecom: value as ADDITIONAL_CATEGORY_TYPE} : item))
                }
              />
            }
            label={label}
          />
        ))}
      </RadioGroup>
      {/* <div className="mt-[16px]">
        <TextField
          className="w-[552px] h-[52px]"
          label="부가서비스명*"
          placeholder="부가서비스명 입력"
          value={list[0].serviceName}
          onChange={(e) =>
            // setForm((state) => ({ ...state, serviceName: e.target.value }))
            setList((prev) => prev.map((item, i) => i === 0 ? {...item, serviceName: e.target.value} : item))
          }
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </div> */}

      {list.length > 0 && (
        <div className="w-full border border-[#E5E5EA] my-[16px]" />
      )}

      <div className="flex flex-col gap-[16px]">
        {list.map((_, index) => {
          return (
            <div className="flex-row-between gap-[12px]" key={index}>
              <TextField
                className="w-full h-[52px]"
                label={`${!!telecom && TELECOM_NAME[telecom]} 부가서비스명*`}
                placeholder="부가서비스명 입력"
                value={list[index].serviceName}
                onChange={
                  (e) =>
                    setList((prev) =>
                      prev.map((item, i) =>
                        i === index
                          ? { ...item, serviceName: e.target.value }
                          : item
                      )
                    )
                  // setForm((state) => ({ ...state, serviceName: e.target.value }))
                }
                slotProps={{ inputLabel: { shrink: true } }}
              />
              <img
                className="cursor-pointer"
                src="/static/icons/icon_close.svg"
                onClick={() =>
                  setList((prev) => prev.filter((_, i) => i !== index))
                }
              />
            </div>
          );
        })}
      </div>

      <Button
        label={`${telecom ? TELECOM_NAME[telecom] : ""} 부가서비스 추가`}
        className="w-full mt-[16px]"
        disabled={telecom === undefined}
        variant={telecom ? "primary" : "disabled"}
        onClick={() =>
          setList((prev) => {
            const newItem = {
              serviceCode: "", serviceId: list.length, serviceName: "", telecom: telecom, isDefault: false
            } as AdditionInstance
            return [...prev, newItem];
          })
        }
      />
    </ConfirmModal>
  );
};
